import { usePromisedRequest as promiseRequest } from "../Common/request";
import { Mat } from "../Common/types";
import { resolveNoContent, resolveWithBody } from "./Utils/utils";

export type CreateMatRequest = {
    eventId: number;
    name: string;
};

export type UpdateMatRequest = {
    eventId: number;
    matId: number;
    name: string;
};

export type ReorderMatsRequest = {
    matIds: number[];
};

export type MatScheduleDelay = {
    expectedEndTime: string;
    actualEndTime: string;
    delay: number;
};

export default {
    getScheduleDelay(eventId: number, matId: number): Promise<MatScheduleDelay> {
        return promiseRequest<MatScheduleDelay>({
            url: `/api/admin/events/${eventId}/mats/${matId}/schedule-delay`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    getSingleMat(eventId: number, matId: number): Promise<Mat> {
        return promiseRequest<Mat>({
            url: `/api/admin/events/${eventId}/mats/${matId}`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    getMatsListing(eventId: number): Promise<Mat[]> {
        return promiseRequest<Mat[]>({
            url: `/api/admin/events/${eventId}/mats`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    createMat(request: CreateMatRequest): Promise<Mat> {
        return promiseRequest<Mat>({
            url: `/api/admin/events/${request.eventId}/mats`,
            method: "post",
            json: request,
        }).then(resolveWithBody());
    },
    updateMat(request: UpdateMatRequest): Promise<Mat> {
        return promiseRequest<Mat>({
            url: `/api/admin/events/${request.eventId}/mats/${request.matId}`,
            method: "put",
            json: request,
        }).then(resolveWithBody());
    },
    deleteMat(eventId: number, matId: number): Promise<void> {
        return promiseRequest<void>({
            url: `/api/admin/events/${eventId}/mats/${matId}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },
    confirmReorder(eventId: number, request: ReorderMatsRequest) {
        return promiseRequest<void>({
            url: `/api/admin/events/${eventId}/mats/actions/reorder`,
            json: request,
            method: "put",
        }).then(resolveNoContent());
    },
};
